<template>
    <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-btn slot="activator" color="secondary" class="text--primary">Add new direccion de envio</v-btn>
        <v-card>
            <form v-on:submit.prevent="create">
                <v-card-title>
                    <span class="headline">Add new direccion de envio</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.company_name"
                                        :error-messages="errors.collect('data.company_name')"
                                        label="Company name"
                                        data-vv-name="data.company_name"
                                        browser-autocomplete="off"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.shipping_data"
                                        :error-messages="errors.collect('data.shipping_data')"
                                        label="Shipping data"
                                        data-vv-name="data.shipping_data"
                                        browser-autocomplete="off"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                                <v-autocomplete
                                        v-validate="'required'"
                                        :items="countries"
                                        item-text="name"
                                        label="Country"
                                        item-value="id"
                                        v-model="data.country_id"
                                        data-vv-name="data.country_id"
                                        :error-messages="errors.collect('data.country_id')"
                                        browser-autocomplete="off"
                                ></v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { DICCIONARIO } from '../../../../diccionario';

    export default {
        props: ['id'],
        data: () => ({
            dialog: false,
            data : {},
            countries: null
        }),
        created () {
            this.data.cliente_id = this.id;
            this.getSelectCountry();
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        watch: {
            dialog: function() {
                this.data.cliente_id = this.id;
            }
        },
        methods: {
            getSelectCountry () {
                this.$store.dispatch('getSelectCountry').then((res) => {

                    this.countries = res.data;

                }).catch((error) => {

                });
            },
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$emit('created', this.data);
                        this.data = {};
                        this.dialog = false
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = {};
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/clients/components/CreateDireccionEnvioModal.vue